import { c as _c } from "react/compiler-runtime";
import { ChatKit as Chat, useChatKit } from '@openai/chatkit-react';
import { Loader } from '@systemeio/components';
import Script from 'next/script';
import { useEffect, useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useMediaQuery from 'shared/hooks/use-media-query';
import { twJoin, twMerge } from 'tailwind-merge';
import { useChatKitActions } from './hooks';
import { ChatKitArrowFilledIcon, ChatKitArrowIcon, ChatKitStarFilledIcon, ChatKitStarIcon } from './icons';
export const ChatKit = () => {
  const $ = _c(99);
  const [isShown, setIsShown] = useState(false);
  const [isRendered, setIsRendered] = useState(false);
  const [isChatReady, setIsChatReady] = useState(false);
  const {
    t
  } = useLocoTranslation();
  const {
    isTablet,
    isDesktop
  } = useMediaQuery();
  const isTabletOrDesktop = isTablet || isDesktop;
  const {
    getClientSecret,
    escalateSupportRequest,
    setThreadId,
    getThreadId
  } = useChatKitActions();
  let t0;
  if ($[0] !== t) {
    t0 = t("dashboard.chat_kit.disclaimer");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      text: t0
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      color: {
        accent: {
          primary: "hsla(236, 82%, 64%, 1)",
          level: 1
        }
      }
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== getThreadId) {
    t3 = getThreadId();
    $[5] = getThreadId;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("dashboard.chat_kit.placeholder");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = {
      placeholder: t4
    };
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("dashboard.chat_kit.greeting");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("dashboard.chat_kit.prompt_create_funnel");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("dashboard.chat_kit.prompt_create_funnel");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7 || $[18] !== t8) {
    t9 = {
      icon: "circle-question",
      label: t7,
      prompt: t8
    };
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("dashboard.chat_kit.prompt_import_contacts");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t) {
    t11 = t("dashboard.chat_kit.prompt_import_contacts");
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11) {
    t12 = {
      icon: "circle-question",
      label: t10,
      prompt: t11
    };
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t) {
    t13 = t("dashboard.chat_kit.prompt_create_website");
    $[27] = t;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t) {
    t14 = t("dashboard.chat_kit.prompt_create_website");
    $[29] = t;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t13 || $[32] !== t14) {
    t15 = {
      icon: "circle-question",
      label: t13,
      prompt: t14
    };
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t) {
    t16 = t("dashboard.chat_kit.prompt_send_newsletter");
    $[34] = t;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t) {
    t17 = t("dashboard.chat_kit.prompt_send_newsletter");
    $[36] = t;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t16 || $[39] !== t17) {
    t18 = {
      icon: "circle-question",
      label: t16,
      prompt: t17
    };
    $[38] = t16;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== t12 || $[42] !== t15 || $[43] !== t18 || $[44] !== t9) {
    t19 = [t9, t12, t15, t18];
    $[41] = t12;
    $[42] = t15;
    $[43] = t18;
    $[44] = t9;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== t19 || $[47] !== t6) {
    t20 = {
      greeting: t6,
      prompts: t19
    };
    $[46] = t19;
    $[47] = t6;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== getClientSecret) {
    t21 = {
      getClientSecret
    };
    $[49] = getClientSecret;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] !== escalateSupportRequest) {
    t22 = async invocation => {
      if (invocation.name === "create_support_request") {
        ;
        try {
          await escalateSupportRequest(invocation.params);
          return {
            success: true
          };
        } catch (t23) {
          return {
            success: false
          };
        }
      }
      return {
        success: false
      };
    };
    $[51] = escalateSupportRequest;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = () => {
      setIsChatReady(true);
    };
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== setThreadId) {
    t24 = t25 => {
      const {
        threadId
      } = t25;
      return setThreadId(threadId);
    };
    $[54] = setThreadId;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== t1 || $[57] !== t20 || $[58] !== t21 || $[59] !== t22 || $[60] !== t24 || $[61] !== t3 || $[62] !== t5) {
    t25 = {
      disclaimer: t1,
      theme: t2,
      initialThread: t3,
      composer: t5,
      startScreen: t20,
      api: t21,
      onClientTool: t22,
      onReady: t23,
      onThreadChange: t24
    };
    $[56] = t1;
    $[57] = t20;
    $[58] = t21;
    $[59] = t22;
    $[60] = t24;
    $[61] = t3;
    $[62] = t5;
    $[63] = t25;
  } else {
    t25 = $[63];
  }
  const {
    control
  } = useChatKit(t25);
  let t26;
  let t27;
  if ($[64] !== isShown || $[65] !== isTabletOrDesktop) {
    t26 = () => {
      const htmlElement = document.documentElement;
      if (isShown && !isTabletOrDesktop) {
        htmlElement.style.overflow = "hidden";
      } else {
        htmlElement.style.overflow = "";
      }
      return () => {
        htmlElement.style.overflow = "";
      };
    };
    t27 = [isShown, isTabletOrDesktop];
    $[64] = isShown;
    $[65] = isTabletOrDesktop;
    $[66] = t26;
    $[67] = t27;
  } else {
    t26 = $[66];
    t27 = $[67];
  }
  useEffect(t26, t27);
  let t28;
  if ($[68] !== isRendered || $[69] !== isShown) {
    t28 = () => {
      if (!isRendered) {
        setIsRendered(true);
        setIsShown(true);
      } else {
        setIsShown(!isShown);
      }
    };
    $[68] = isRendered;
    $[69] = isShown;
    $[70] = t28;
  } else {
    t28 = $[70];
  }
  const onAIButtonClickHandler = t28;
  let t29;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <Script src="https://cdn.platform.openai.com/deployments/chatkit/chatkit.js" async={true} />;
    $[71] = t29;
  } else {
    t29 = $[71];
  }
  const t30 = isShown && !isChatReady && "animate-pulse";
  const t31 = isTabletOrDesktop ? "bottom-16" : "bottom-32";
  let t32;
  if ($[72] !== t30 || $[73] !== t31) {
    t32 = twMerge("from-6.36% via-23.9% to-70.14% group fixed right-2 bottom-16 z-50 flex h-12 w-12 rounded-full bg-gradient-to-br from-[#4EB2F4] via-[#4076F9] to-[#7A3ADB] transition transition-all hover:scale-110", t30, t31);
    $[72] = t30;
    $[73] = t31;
    $[74] = t32;
  } else {
    t32 = $[74];
  }
  const t33 = isShown && !isChatReady;
  let t34;
  if ($[75] !== isShown) {
    t34 = !isShown && <><ChatKitStarIcon style={{
        width: 28
      }} className={twMerge("absolute bottom-1/2 left-1/2 -translate-x-1/2 translate-y-1/2 opacity-100 transition-all duration-300 ease-in-out group-hover:opacity-0")} /><ChatKitStarFilledIcon style={{
        width: 40
      }} className={twMerge("absolute bottom-1/2 left-1/2 -translate-x-1/2 translate-y-1/2 opacity-0 transition-all duration-300 ease-in-out group-hover:opacity-100")} /></>;
    $[75] = isShown;
    $[76] = t34;
  } else {
    t34 = $[76];
  }
  let t35;
  if ($[77] !== isChatReady || $[78] !== isShown) {
    t35 = isShown && !isChatReady && <span className={twMerge("absolute bottom-1/2 left-2/3 -translate-x-1/2 translate-y-1/2 opacity-100 transition-all duration-300 ease-in-out group-hover:opacity-0")}><Loader color="white" size="lg" /></span>;
    $[77] = isChatReady;
    $[78] = isShown;
    $[79] = t35;
  } else {
    t35 = $[79];
  }
  let t36;
  if ($[80] !== isChatReady || $[81] !== isShown) {
    t36 = isShown && isChatReady && <><ChatKitArrowIcon style={{
        width: 28
      }} className={twMerge("absolute bottom-1/2 left-1/2 -translate-x-1/2 translate-y-1/2 opacity-100 transition-all duration-300 ease-in-out group-hover:opacity-0")} /><ChatKitArrowFilledIcon style={{
        width: 40
      }} className={twMerge("absolute bottom-1/2 left-1/2 -translate-x-1/2 translate-y-1/2 opacity-0 transition-all duration-300 ease-in-out group-hover:opacity-100")} /></>;
    $[80] = isChatReady;
    $[81] = isShown;
    $[82] = t36;
  } else {
    t36 = $[82];
  }
  let t37;
  if ($[83] !== onAIButtonClickHandler || $[84] !== t32 || $[85] !== t33 || $[86] !== t34 || $[87] !== t35 || $[88] !== t36) {
    t37 = <button onClick={onAIButtonClickHandler} className={t32} disabled={t33}>{t34}{t35}{t36}</button>;
    $[83] = onAIButtonClickHandler;
    $[84] = t32;
    $[85] = t33;
    $[86] = t34;
    $[87] = t35;
    $[88] = t36;
    $[89] = t37;
  } else {
    t37 = $[89];
  }
  let t38;
  if ($[90] !== control || $[91] !== isChatReady || $[92] !== isRendered || $[93] !== isShown || $[94] !== isTabletOrDesktop) {
    t38 = isRendered && <div className={twJoin("tablet:shadow-3 tablet:h-[600px] tablet:w-[320px] tablet:overflow-hidden tablet:rounded-md fixed z-49 h-full w-full transition-all duration-300", isTabletOrDesktop ? "right-10 bottom-14" : "top-0 right-0 bottom-0 left-0", isShown && isChatReady ? "scale-100 opacity-100" : "pointer-events-none scale-0 opacity-0")}><Chat control={control} /></div>;
    $[90] = control;
    $[91] = isChatReady;
    $[92] = isRendered;
    $[93] = isShown;
    $[94] = isTabletOrDesktop;
    $[95] = t38;
  } else {
    t38 = $[95];
  }
  let t39;
  if ($[96] !== t37 || $[97] !== t38) {
    t39 = <>{t29}{t37}{t38}</>;
    $[96] = t37;
    $[97] = t38;
    $[98] = t39;
  } else {
    t39 = $[98];
  }
  return t39;
};